import useAuth from "./useAuth";

export default function useIsDinteroRoot() {
    const exchangeTokenPartnerId = useAuth(
        (state) => state.exchangeTokenPartnerId,
    );
    return exchangeTokenPartnerId === "P00000000";
}
